// import React, { useState } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";


// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours) *
//       Number(form.headcount)
//     );
//   };

//   // 🔥 NEW FUNCTION (ADDED ONLY THIS)
//   function numberToWords(num) {
//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const convert = (n) => {
//       if (n < 20) return ones[n];
//       if (n < 100)
//         return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
//       if (n < 1000)
//         return ones[Math.floor(n / 100)] + " Hundred" +
//           (n % 100 ? " " + convert(n % 100) : "");
//       if (n < 1000000)
//         return convert(Math.floor(n / 1000)) + " Thousand" +
//           (n % 1000 ? " " + convert(n % 1000) : "");
//       return "";
//     };

//     return convert(num) + " dollars only";
//   }

//   const downloadPDF = async () => {



//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

//     const total = calculateTotal();
//       const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     // 🔥 WRITE DATA ON PDF

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont

//     });

//     // 🔥 ONLY THIS LINE CHANGED
//     const words = numberToWords(total);

//     page.drawText(words, {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });

//     const pdfBytes = await pdfDoc.save();

//     const blob = new Blob([pdfBytes], { type: "application/pdf" });
//     const url = URL.createObjectURL(blob);

//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "Invoice.pdf";
//     a.click();
//   };

//   return (
//     <div style={{ padding: "20px" }}>

//       <h2>CREATE INVOICE</h2>

//       <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//         <input name="rate" placeholder="Rate" onChange={handleChange} />
//         <input name="hours" placeholder="Hours" onChange={handleChange} />
//         <input name="headcount" placeholder="Headcount" onChange={handleChange} />

//         <input type="date" name="invoiceDate" onChange={handleChange} />
//         <input type="date" name="serviceDate" onChange={handleChange} />

//         <input name="buyer" placeholder="Buyer Name" onChange={handleChange} />
//         <input name="address" placeholder="Address" onChange={handleChange} />
//         <input name="country" placeholder="Country" onChange={handleChange} />

//         <button onClick={downloadPDF}>Download PDF</button>
//       </div>

//       <div style={{ marginTop: "20px" }}>
//         <iframe
//           src="/InvoiceTemplate.pdf"
//           width="100%"
//           height="700px"
//           title="Invoice Preview"
//         />
//       </div>

//     </div>
//   );
// }









// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours) *
//       Number(form.headcount)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//  function numberToWords(num) {
//   if (num === 0) return "Zero Dollars Only";

//   const ones = [
//     "", "One", "Two", "Three", "Four", "Five", "Six",
//     "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//     "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//     "Seventeen", "Eighteen", "Nineteen"
//   ];

//   const tens = [
//     "", "", "Twenty", "Thirty", "Forty", "Fifty",
//     "Sixty", "Seventy", "Eighty", "Ninety"
//   ];

//   const thousands = ["", "Thousand", "Million", "Billion"];

//   function convertHundreds(n) {
//     let str = "";

//     if (n > 99) {
//       str += ones[Math.floor(n / 100)] + " Hundred ";
//       n %= 100;
//     }

//     if (n > 19) {
//       str += tens[Math.floor(n / 10)] + " ";
//       n %= 10;
//     }

//     if (n > 0) {
//       str += ones[n] + " ";
//     }

//     return str.trim();
//   }

//   let word = "";
//   let i = 0;

//   while (num > 0) {
//     if (num % 1000 !== 0) {
//       word =
//         convertHundreds(num % 1000) +
//         " " +
//         thousands[i] +
//         " " +
//         word;
//     }
//     num = Math.floor(num / 1000);
//     i++;
//   }

//   return word.trim() + " Dollars Only";
// }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });

//     return await pdfDoc.save();
//   };

//   // 🔥 Live Preview
//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = "Invoice.pdf";
//     a.click();
//   };

//   return (
//     <div className="main-container">

//       {/* LEFT PANEL */}
//       <div className="form-section">

//         <h2>⚡ Create Invoice</h2>



//         {/* FORM */}
//         <div className="form-grid">
//           <input name="rate" placeholder="Rate" onChange={handleChange} />
//           <input name="hours" placeholder="Hours" onChange={handleChange} />
//           <input name="headcount" placeholder="Headcount" onChange={handleChange} />

//           <input type="date" name="invoiceDate" onChange={handleChange} />
//           <input type="date" name="serviceDate" onChange={handleChange} />

//           <input name="buyer" placeholder="Buyer Name" onChange={handleChange} />
//           <input name="address" placeholder="Address" onChange={handleChange} />
//           <input name="country" placeholder="Country" onChange={handleChange} />
//         </div>

//         {/* TOTAL */}
//         {/* TOTAL */}
//         <div className="total-box">
//           <span>Total Amount</span>
//           <strong>${calculateTotal().toLocaleString()}</strong>
//         </div>

//         {/* 🔥 PROGRESS (MOVED HERE) */}
//         <div className="progress-wrapper bottom-progress">
//           <div className="progress-bar">
//             <div style={{ width: `${progress}%` }} />
//           </div>
//           <div className="progress-info">
//             <span>{filled} / {fields.length} fields completed</span>
//             <span>{progress}%</span>
//           </div>
//         </div>

//         {/* BUTTON */}
//         <button
//           disabled={!isComplete}
//           className={isComplete ? "btn-active" : "btn-disabled"}
//           onClick={downloadPDF}
//         >
//           Generate PDF
//         </button>
//       </div>

//       {/* RIGHT PREVIEW */}
//       <div className="preview-section">
//         <div className="preview-card">
//           <div className="preview-header">Live Invoice Preview</div>

//           {previewUrl ? (
//             <iframe src={previewUrl} title="preview" />
//           ) : (
//             <p style={{ color: "#64748b" }}>Fill details to preview</p>
//           )}
//         </div>
//       </div>

//     </div>
//   );
// }










// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours) *
//       Number(form.headcount)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = "Invoice.pdf";
//     a.click();
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">
//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>
//             <option>2024</option>
//             <option>2025</option>
//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">
//             <h2>⚡ Create Invoice</h2>

//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate"  onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input name="hours"  onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount"  onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input type="date" name="invoiceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input type="date" name="serviceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer"  onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address"  onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country"  onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 <iframe
//                   src={`${previewUrl}#toolbar=0`}
//                   title="preview"
//                 />
//               ) : (
//                 <p style={{ color: "#64748b" }}>Fill details to preview</p>
//               )}
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }


















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     let updatedForm = { ...form, [name]: value };

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(
//       name === "month" ? value : updatedForm.month,
//       name === "year" ? value : updatedForm.year
//     );

//     // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//     if (
//       name === "headcount" ||
//       name === "month" ||
//       name === "year"
//     ) {
//       const headcount = Number(
//         name === "headcount" ? value : updatedForm.headcount
//       ) || 0;

//       const twhm = headcount * hoursPerDay * workingDays;

//       updatedForm.hours = twhm;
//     }

//     setForm(updatedForm);
//   };
//  const calculateTotal = () => {
//   return (
//     Number(form.rate) *
//     Number(form.hours)
//   ) || 0;
// };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = "Invoice.pdf";
//     a.click();
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           {/* <div className="working-days">
//   Working Days: {getWorkingDays(form.month, form.year)}
// </div> */}
//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">
//             {/* <h2>⚡ Create Invoice</h2> */}
//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               <div className="working-days-badge">
//                 Working Days: {getWorkingDays(form.month, form.year)}
//               </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input type="date" name="invoiceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input type="date" name="serviceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 <iframe
//                   src={`${previewUrl}#toolbar=0`}
//                   title="preview"
//                 />
//               ) : (
//                 <p style={{ color: "#64748b" }}>Fill details to preview</p>
//               )}
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     let updatedForm = { ...form, [name]: value };

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(
//       name === "month" ? value : updatedForm.month,
//       name === "year" ? value : updatedForm.year
//     );

//     // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//     if (
//       name === "headcount" ||
//       name === "month" ||
//       name === "year"
//     ) {
//       const headcount = Number(
//         name === "headcount" ? value : updatedForm.headcount
//       ) || 0;

//       const twhm = headcount * hoursPerDay * workingDays;

//       updatedForm.hours = twhm;
//     }

//     setForm(updatedForm);
//   };
//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">
//             {/* <h2>⚡ Create Invoice</h2> */}
//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               <div className="invoice-no-box">
//                 <span>
//                   GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                 </span>

//                 <div className="invoice-controls">
//                   <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                   <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                 </div>
//               </div>

//               <div className="working-days-badge">
//                 Working Days: {getWorkingDays(form.month, form.year)}
//               </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input type="date" name="invoiceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input type="date" name="serviceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 <iframe
//                   src={`${previewUrl}#toolbar=0`}
//                   title="preview"
//                 />
//               ) : (
//                 <p style={{ color: "#64748b" }}>Fill details to preview</p>
//               )}
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }




















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     let updatedForm = { ...form, [name]: value };

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(
//       name === "month" ? value : updatedForm.month,
//       name === "year" ? value : updatedForm.year
//     );

//     // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//     if (
//       name === "headcount" ||
//       name === "month" ||
//       name === "year"
//     ) {
//       const headcount = Number(
//         name === "headcount" ? value : updatedForm.headcount
//       ) || 0;

//       const twhm = headcount * hoursPerDay * workingDays;

//       updatedForm.hours = twhm;
//     }

//     setForm(updatedForm);
//   };
//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">
//             {/* <h2>⚡ Create Invoice</h2> */}
//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               <div className="invoice-no-box">
//                 <span>
//                   GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                 </span>

//                 <div className="invoice-controls">
//                   <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                   <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                 </div>
//               </div>

//               <div className="working-days-badge">
//                 Working Days: {getWorkingDays(form.month, form.year)}
//               </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input type="date" name="invoiceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input type="date" name="serviceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 <iframe
//                   src={`${previewUrl}#toolbar=0`}
//                   title="preview"
//                 />
//               ) : (
//                 <p style={{ color: "#64748b" }}>Fill details to preview</p>
//               )}
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }








// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "",
//     address: "",
//     country: ""
//   });

//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       const res = await fetch(`/gt-api/get_all_leaves.php`);
//       const data = await res.json();

//       if (!data.success) return;

//       const monthMap = {
//         Jan: "1", Feb: "2", Mar: "3", Apr: "4",
//         May: "5", Jun: "6", Jul: "7", Aug: "8",
//         Sep: "9", Oct: "10", Nov: "11", Dec: "12"
//       };

//       const selectedMonth = monthMap[form.month];
//       const selectedYear = form.year;

//       const filtered = data.leaves.filter(l => {
//         const dateParts = l.fromdate?.split("-");
//         const lYear = dateParts?.[0];
//         const lMonth = parseInt(dateParts?.[1])?.toString();

//         return (
//           l.Department === form.department &&
//           l.Status === '1' && // ONLY APPROVED
//           lMonth === selectedMonth &&
//           lYear === selectedYear
//         );
//       });

//       const totalLeaveDays = filtered.reduce(
//         (sum, l) => sum + (parseFloat(l.total) || 0),
//         0
//       );

//       const hoursPerDay = 9;
//       const leaveHours = totalLeaveDays * hoursPerDay;

//       setLeaveDeduction({
//         days: totalLeaveDays,
//         hours: leaveHours
//       });

//     } catch (err) {
//       console.error("Leave fetch error", err);
//     }
//   };

//   useEffect(() => {
//     if (form.department && form.month && form.year) {
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     let updatedForm = { ...form, [name]: value };

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(
//       name === "month" ? value : updatedForm.month,
//       name === "year" ? value : updatedForm.year
//     );

//     // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//     if (
//       name === "headcount" ||
//       name === "month" ||
//       name === "year"
//     ) {
//       const headcount = Number(
//         name === "headcount" ? value : updatedForm.headcount
//       ) || 0;

//       const baseTWHM = headcount * hoursPerDay * workingDays;
//       const finalTWHM = baseTWHM - (leaveDeduction.hours || 0);

//       updatedForm.hours = Math.max(0, finalTWHM);

//       updatedForm.hours = finalTWHM;
//     }

//     setForm(updatedForm);
//   };
//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">
//             {/* <h2>⚡ Create Invoice</h2> */}
//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               <div className="invoice-no-box">
//                 <span>
//                   GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                 </span>

//                 <div className="invoice-controls">
//                   <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                   <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                 </div>
//               </div>

//            <div className="working-days-badge">
//   Working Days: {getWorkingDays(form.month, form.year)}

//   {leaveDeduction.days > 0 && (
//     <span className="leave-inline">
//       {" "} | ⚠ {leaveDeduction.days} leaves → {leaveDeduction.hours} hrs deducted
//     </span>
//   )}
// </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input type="date" name="invoiceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input type="date" name="serviceDate" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 <iframe
//                   src={`${previewUrl}#toolbar=0`}
//                   title="preview"
//                 />
//               ) : (
//                 <p style={{ color: "#64748b" }}>Fill details to preview</p>
//               )}
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }





























// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA"
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 9;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const calculateTotal = () => {
//     return (
//       Number(form.rate) *
//       Number(form.hours)
//     ) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">

//             {/* <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               <div className="invoice-no-box">
//                 <span>
//                   GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                 </span>

//                 <div className="invoice-controls">
//                   <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                   <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                 </div>
//               </div>

//               <div className="metrics-row">

//                 <div className="metric-card working-days-card">
//                   <div className="metric-title">WORKING DAYS</div>
//                   <div className="metric-value">
//                     {getWorkingDays(form.month, form.year)}
//                   </div>
//                 </div>

//                 <div className="metric-card deduction-card">
//                   <div className="metric-title">DEDUCTION</div>

//                   {leaveLoading ? (
//                     <div className="metric-note">Calculating...</div>
//                   ) : leaveDeduction.days > 0 ? (
//                     <div className="metric-note">
//                       ⚠ {leaveDeduction.days} days <br />
//                       {leaveDeduction.hours} hrs deducted
//                     </div>
//                   ) : (
//                     <div className="metric-note success">
//                       No deductions
//                     </div>
//                   )}
//                 </div>

//               </div>
//             </div> */}


//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days <br />
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input
//                   type="date"
//                   name="invoiceDate"
//                   value={form.invoiceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" value={form.buyer} onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" value={form.address} onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" value={form.country} onChange={handleChange} />
//               </div>

//             </div>

//             <div className="total-box">
//               <span>Total Amount</span>
//               <strong>${calculateTotal().toLocaleString()}</strong>
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 // <iframe
//                 //   src={`${previewUrl}#toolbar=0`}
//                 //   title="preview"
//                 // />
//                 <iframe
//                   src={`${previewUrl}#toolbar=0&zoom=page-width`}
//                   title="preview"
//                 />
//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }

















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 9;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   // const calculateTotal = () => {
//   //   return (
//   //     Number(form.rate) *
//   //     Number(form.hours)
//   //   ) || 0;
//   // };
//   const calculateTotal = () => {
//     // 🔥 If user entered manual total → use it
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     // 🔥 Otherwise auto calculate
//     return (Number(form.rate) * Number(form.hours)) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const total = calculateTotal();

//     page.drawText(form.invoiceDate || "", { x: 204.5, y: 595, size: 10, font });
//     page.drawText(form.serviceDate || "", { x: 204.5, y: 581, size: 10, font });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days <br />
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>


//             <div className="form-grid">

//               <div className="field">
//                 <label>Rate</label>
//                 <input name="rate" onChange={handleChange} />
//               </div>



//               <div className="field">
//                 <label>Headcount</label>
//                 <input name="headcount" onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>TWHM</label>
//                 <input
//                   name="hours"
//                   value={form.hours}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Date of Invoice</label>
//                 <input
//                   type="date"
//                   name="invoiceDate"
//                   value={form.invoiceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Service Rendered Date</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Name of the Buyer</label>
//                 <input name="buyer" value={form.buyer} onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Address</label>
//                 <input name="address" value={form.address} onChange={handleChange} />
//               </div>

//               <div className="field">
//                 <label>Country Name</label>
//                 <input name="country" value={form.country} onChange={handleChange} />
//               </div>

//             </div>


//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 // <iframe
//                 //   src={`${previewUrl}#toolbar=0`}
//                 //   title="preview"
//                 // />
//                 <iframe
//                   src={`${previewUrl}#toolbar=0&zoom=page-width`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }

















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 9;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   // const calculateTotal = () => {
//   //   return (
//   //     Number(form.rate) *
//   //     Number(form.hours)
//   //   ) || 0;
//   // };
//   const calculateTotal = () => {
//     // 🔥 If user entered manual total → use it
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     // 🔥 Otherwise auto calculate
//     return (Number(form.rate) * Number(form.hours)) || 0;
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days <br />
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>


//             <div className="form-grid">

//               {/* 🔥 ROW 1 */}
//               <div className="field-row compact-row">
//                 <div className="field small">
//                   <label>Rate</label>
//                   <input name="rate" onChange={handleChange} />
//                 </div>

//                 <div className="field small">
//                   <label>Headcount</label>
//                   <input name="headcount" onChange={handleChange} />
//                 </div>

//                 <div className="field small">
//                   <label>TWHM</label>
//                   <input
//                     name="hours"
//                     value={form.hours}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* 🔥 ROW 2 */}
//               <div className="field-row">
//                 <div className="field">
//                   <label>Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* 🔥 ROW 3 */}
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>





//             </div>


//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 // <iframe
//                 //   src={`${previewUrl}#toolbar=0`}
//                 //   title="preview"
//                 // />
//                 <iframe
//                   src={`${previewUrl}#toolbar=0&zoom=page-width`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }
















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "" }
//   ]);

//   const [form, setForm] = useState({
//     department: "",   // ✅ NEW
//     month: "",        // ✅ NEW
//     year: "",         // ✅ NEW
//     rate: "",
//     hours: "",
//     headcount: "",
//     invoiceDate: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 9;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM
//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;

//     const hoursPerDay = 9;
//     const workingDays = getWorkingDays(form.month, form.year);
//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const updatedItems = lineItems.map(item => {
//       const headcount = Number(item.headcount) || 0;

//       const baseTWHM = headcount * hoursPerDay * workingDays;
//       const finalTWHM = baseTWHM - deductionHours;

//       return {
//         ...item,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 9;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       { rate: "", headcount: "", hours: "" }
//     ]);
//   };


//   // const calculateTotal = () => {

//   //   if (form.total !== "") {
//   //     return Number(form.total) || 0;
//   //   }


//   //   return (Number(form.rate) * Number(form.hours)) || 0;
//   // };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 Progress Logic
//   const fields = Object.values(form);
//   const filled = fields.filter(v => v !== "").length;
//   const progress = Math.round((filled / fields.length) * 100);
//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days <br />
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>
//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>
//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>



//             </div>
//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {fields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 // <iframe
//                 //   src={`${previewUrl}#toolbar=0`}
//                 //   title="preview"
//                 // />
//                 <iframe
//                   src={`${previewUrl}#toolbar=0&zoom=page-width`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }





















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay =8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM
//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);
//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const updatedItems = lineItems.map(item => {
//       // ❌ skip auto calculation for manual rows
//       if (!item.auto) return item;

//       const headcount = Number(item.headcount) || 0;

//       const baseTWHM = headcount * hoursPerDay * workingDays;
//       const finalTWHM = baseTWHM - deductionHours;

//       return {
//         ...item,
//         hours: Math.max(0, finalTWHM)
//       };
//     });
//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       { rate: "", headcount: "", hours: 0, auto: false } // ❌ manual row
//     ]);
//   };



//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//  // 🔥 remove total
// const { total, ...restForm } = form;

// // 🔥 form fields
// const formFields = Object.values(restForm);

// // 🔥 line items
// const lineItemFields = lineItems.flatMap(item => [
//   item.rate,
//   item.headcount,
//   item.hours
// ]);

// // 🔥 combine
// const allFields = [...formFields, ...lineItemFields];

// // 🔥 count
// const filled = allFields.filter(v => v !== "" && v !== null).length;

// // 🔥 %
// const progress = Math.round((filled / allFields.length) * 100);

// const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = 
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>
//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>
//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>



//             </div>
//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <div className="progress-info">
//                 <span>{filled} / {allFields.length} fields completed</span>
//                 <span>{progress}%</span>
//               </div>
//             </div>

//             <div className="btn-wrapper">
//               <button
//                 disabled={!isComplete}
//                 className={isComplete ? "btn-active" : "btn-disabled"}
//                 onClick={downloadPDF}
//               >
//                 Generate PDF
//               </button>
//             </div>
//           </div>

//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <div className="preview-header">Live Invoice Preview</div>

//               {previewUrl ? (
//                 // <iframe
//                 //   src={`${previewUrl}#toolbar=0`}
//                 //   title="preview"
//                 // />
//                 <iframe
//                   src={`${previewUrl}#toolbar=0&zoom=page-width`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }

















// working before implementing type 1 type 2

// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });

//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM
//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);
//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const updatedItems = lineItems.map(item => {
//       // ❌ skip auto calculation for manual rows
//       if (!item.auto) return item;

//       const headcount = Number(item.headcount) || 0;

//       const baseTWHM = headcount * hoursPerDay * workingDays;
//       const finalTWHM = baseTWHM - deductionHours;

//       return {
//         ...item,
//         hours: Math.max(0, finalTWHM)
//       };
//     });
//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       { rate: "", headcount: "", hours: 0, auto: false } // ❌ manual row
//     ]);
//   };



//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">
//                     <div className="metric-title">DEDUCTION</div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days =
//                         {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}
//                   </div>
//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>
//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>
//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>



//             </div>
//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//     </div>
//   );
// }






























// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM
//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);
//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const updatedItems = lineItems.map(item => {
//       // ❌ skip auto calculation for manual rows
//       if (!item.auto) return item;

//       const headcount = Number(item.headcount) || 0;

//       const baseTWHM = headcount * hoursPerDay * workingDays;
//       const finalTWHM = baseTWHM - deductionHours;

//       return {
//         ...item,
//         hours: Math.max(0, finalTWHM)
//       };
//     });
//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       { rate: "", headcount: "", hours: 0, auto: false } // ❌ manual row
//     ]);
//   };



//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };
//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>
//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>
//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>



//             </div>
//             <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div>

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
// {showLeaveModal && (
//   <div
//     className="modal-overlay"
//     onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//   >
//     <div
//       className="modal-box large-modal"
//       onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//     >

//       {/* HEADER */}
//       <div className="modal-header">
//         <h3>Leave Details</h3>
//         <button
//           className="close-btn"
//           onClick={() => setShowLeaveModal(false)}
//         >
//           ✕
//         </button>
//       </div>

//       {/* TABLE */}
//       <table className="leave-table big-table">
//         <thead>
//           <tr>
//             <th>Name</th>
//             <th>Unit</th>
//             <th>Type</th>
//           </tr>
//         </thead>

//         <tbody>
//           {leaveEmployees.length > 0 ? (
//             leaveEmployees.map((emp, i) => (
//               <tr key={i}>
//                 <td>{emp.name}</td>
//                 <td>{emp.unit}</td>
//                 <td>
//                   <select className="type-dropdown">
//                     <option>Type1</option>
//                     <option>Type2</option>
//                     <option>Type3</option>
//                     <option>Type4</option>
//                     <option>Type5</option>
//                   </select>
//                 </td>
//               </tr>
//             ))
//           ) : (
//             <tr>
//               <td colSpan="3" className="no-data">
//                 No leave records
//               </td>
//             </tr>
//           )}
//         </tbody>
//       </table>

//     </div>
//   </div>
// )}
//     </div>
//   );
// }



































// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);
//   const [employeeTypes, setEmployeeTypes] = useState({});
//   const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
//   const [headcountErrors, setHeadcountErrors] = useState({});

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });
//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;
//     if (!leaveEmployees.length) return; // ✅ ADD THIS

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);

//     // 🔥 ALWAYS START FROM BASE
//     let updatedItems = lineItems.map((item) => {
//       const headcount = Number(item.headcount || 0);
//       const baseTWHM = headcount * hoursPerDay * workingDays;

//       return {
//         ...item,
//         hours: baseTWHM
//       };
//     });

//     // 🔥 GROUP
//     const typeTotals = {};

//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       const emp = leaveEmployees[empIndex];

//       if (!type || !emp) return;

//       if (!typeTotals[type]) {
//         typeTotals[type] = 0;
//       }

//       typeTotals[type] += Number(emp.unit || 0);
//     });

//     // 🔥 APPLY ONCE
//     Object.keys(typeTotals).forEach((type) => {
//       const rowIndex = Number(type) - 1;

//       if (!updatedItems[rowIndex]) return;

//       const totalUnits = typeTotals[type];

//       updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveLoading,
//     employeeTypes,
//     leaveEmployees
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);



//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);

//     // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
//     if (name === "headcount") {
//       const type = index + 1; // row1 → Type1

//       let selectedCount = 0;

//       // count employees selected for this type
//       Object.keys(employeeTypes).forEach((empIndex) => {
//         if (Number(employeeTypes[empIndex]) === type) {
//           selectedCount++;
//         }
//       });

//       const enteredHeadcount = Number(value || 0);

//       setHeadcountErrors(prev => ({
//         ...prev,
//         [index]:
//           enteredHeadcount < selectedCount
//             ? `Minimum ${selectedCount} required`
//             : ""
//       }));
//     }
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       {
//         rate: "",
//         headcount: "",
//         hours: 0,
//         auto: false
//       }
//     ]);
//   };

//   const deleteLineItem = (index) => {
//     setLineItems(prev => prev.filter((_, i) => i !== index));
//   };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const validateHeadcount = () => {
//     const typeCounts = {};

//     // count employees per type
//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       if (!type) return;

//       if (!typeCounts[type]) {
//         typeCounts[type] = 0;
//       }

//       typeCounts[type]++;
//     });

//     // validate against lineItems
//     for (let type in typeCounts) {
//       const rowIndex = Number(type) - 1;

//       const selectedEmployees = typeCounts[type];
//       const headcount = Number(lineItems[rowIndex]?.headcount || 0);

//       if (headcount < selectedEmployees) {
//         alert(
//           `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
//         );
//         return false;
//       }
//     }

//     return true;
//   };

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };

//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>

//                     {/* TOP RIGHT DELETE ICON */}
//                     <span
//                       className="delete-icon"
//                       onClick={() => deleteLineItem(index)}
//                     >
//                       ✖
//                     </span>

//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>

//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                         className={headcountErrors[index] ? "input-error" : ""}
//                       />

//                       {headcountErrors[index] && (
//                         <div className="error-text">
//                           {headcountErrors[index]}
//                         </div>
//                       )}
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div> */}



//             </div>
//             <div className="row">
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Total Amount</label>

//                 <div className="currency-input">
//                   <span className="currency-symbol">$</span>

//                   <input
//                     name="total"
//                     value={form.total !== "" ? form.total : calculateTotal()}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div> */}

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//       {showLeaveModal && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//         >
//           <div
//             className="modal-box large-modal"
//             onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//           >

//             {/* HEADER */}
//             <div className="modal-header">
//               <h3>Leave Details</h3>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowLeaveModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             {/* TABLE */}
//             <table className="leave-table big-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Unit</th>
//                   <th>Type</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {leaveEmployees.length > 0 ? (
//                   leaveEmployees.map((emp, i) => (
//                     <tr key={i}>
//                       <td>{emp.name}</td>
//                       <td>{emp.unit}</td>
//                       <td>
//                         <select
//                           className="type-dropdown"
//                           value={tempEmployeeTypes[i] || ""}
//                           onChange={(e) => {
//                             const updated = {
//                               ...tempEmployeeTypes,
//                               [i]: e.target.value
//                             };
//                             setTempEmployeeTypes(updated);
//                           }}
//                         >
//                           <option value="">Select</option>
//                           <option value="1">Type1</option>
//                           <option value="2">Type2</option>
//                           <option value="3">Type3</option>
//                           <option value="4">Type4</option>
//                           <option value="5">Type5</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="no-data">
//                       No leave records
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* 🔥 APPLY BUTTON (added below table) */}
//             <div className="modal-footer">
//               <button
//                 className="apply-btn"
//                 onClick={() => {
//                   setEmployeeTypes(tempEmployeeTypes);
//                   setShowLeaveModal(false);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }


















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import Select from "react-select";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);
//   const [employeeTypes, setEmployeeTypes] = useState({});
//   const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
//   const [headcountErrors, setHeadcountErrors] = useState({});

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });


//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;
//     if (!leaveEmployees.length) return; // ✅ ADD THIS

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);

//     // 🔥 ALWAYS START FROM BASE
//     let updatedItems = lineItems.map((item) => {
//       const headcount = Number(item.headcount || 0);
//       const baseTWHM = headcount * hoursPerDay * workingDays;

//       return {
//         ...item,
//         hours: baseTWHM
//       };
//     });

//     // 🔥 GROUP
//     const typeTotals = {};

//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       const emp = leaveEmployees[empIndex];

//       if (!type || !emp) return;

//       if (!typeTotals[type]) {
//         typeTotals[type] = 0;
//       }

//       typeTotals[type] += Number(emp.unit || 0);
//     });

//     // 🔥 APPLY ONCE
//     Object.keys(typeTotals).forEach((type) => {
//       const rowIndex = Number(type) - 1;

//       if (!updatedItems[rowIndex]) return;

//       const totalUnits = typeTotals[type];

//       updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveLoading,
//     employeeTypes,
//     leaveEmployees
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   useEffect(() => {
//     if (!form.month || !form.year) return;

//     const monthIndexMap = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     };

//     const monthIndex = monthIndexMap[form.month];
//     const year = Number(form.year);

//     const lastDay = new Date(year, monthIndex + 1, 0).getDate();

//     const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;

//     setForm(prev => {
//       if (prev.serviceDate === formattedDate) return prev;

//       return {
//         ...prev,
//         serviceDate: formattedDate
//       };
//     });

//   }, [form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);

//     // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
//     if (name === "headcount") {
//       const type = index + 1; // row1 → Type1

//       let selectedCount = 0;

//       // count employees selected for this type
//       Object.keys(employeeTypes).forEach((empIndex) => {
//         if (Number(employeeTypes[empIndex]) === type) {
//           selectedCount++;
//         }
//       });

//       const enteredHeadcount = Number(value || 0);

//       setHeadcountErrors(prev => ({
//         ...prev,
//         [index]:
//           enteredHeadcount < selectedCount
//             ? `Minimum ${selectedCount} required`
//             : ""
//       }));
//     }
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       {
//         rate: "",
//         headcount: "",
//         hours: 0,
//         auto: false
//       }
//     ]);
//   };

//   const deleteLineItem = (index) => {
//     setLineItems(prev => prev.filter((_, i) => i !== index));
//   };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const validateHeadcount = () => {
//     const typeCounts = {};

//     // count employees per type
//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       if (!type) return;

//       if (!typeCounts[type]) {
//         typeCounts[type] = 0;
//       }

//       typeCounts[type]++;
//     });

//     // validate against lineItems
//     for (let type in typeCounts) {
//       const rowIndex = Number(type) - 1;

//       const selectedEmployees = typeCounts[type];
//       const headcount = Number(lineItems[rowIndex]?.headcount || 0);

//       if (headcount < selectedEmployees) {
//         alert(
//           `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
//         );
//         return false;
//       }
//     }

//     return true;
//   };

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };

//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         <div className="header-bar">

//           <select name="department" onChange={handleChange}>
//             <option value="">Department</option>
//             <option>FI Design</option>
//             <option>FSPLO</option>
//             <option>LTDM PC</option>
//             <option>DDI</option>
//             <option>DMS</option>
//             <option>FI-IE</option>
//             <option>LTO</option>
//           </select>

//           <select name="month" onChange={handleChange}>
//             <option value="">Month</option>
//             <option>Jan</option>
//             <option>Feb</option>
//             <option>Mar</option>
//             <option>Apr</option>
//             <option>May</option>
//             <option>Jun</option>
//             <option>Jul</option>
//             <option>Aug</option>
//             <option>Sep</option>
//             <option>Oct</option>
//             <option>Nov</option>
//             <option>Dec</option>
//           </select>

//           <select name="year" onChange={handleChange}>
//             <option value="">Year</option>

//             <option>2026</option>
//             <option>2027</option>
//           </select>
//         </div>

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>

//                     {/* TOP RIGHT DELETE ICON */}
//                     <span
//                       className="delete-icon"
//                       onClick={() => deleteLineItem(index)}
//                     >
//                       ✖
//                     </span>

//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>

//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                         className={headcountErrors[index] ? "input-error" : ""}
//                       />

//                       {headcountErrors[index] && (
//                         <div className="error-text">
//                           {headcountErrors[index]}
//                         </div>
//                       )}
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div> */}



//             </div>
//             <div className="row">
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Total Amount</label>

//                 <div className="currency-input">
//                   <span className="currency-symbol">$</span>

//                   <input
//                     name="total"
//                     value={form.total !== "" ? form.total : calculateTotal()}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div> */}

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//       {showLeaveModal && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//         >
//           <div
//             className="modal-box large-modal"
//             onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//           >

//             {/* HEADER */}
//             <div className="modal-header">
//               <h3>Leave Details</h3>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowLeaveModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             {/* TABLE */}
//             <table className="leave-table big-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Unit</th>
//                   <th>Type</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {leaveEmployees.length > 0 ? (
//                   leaveEmployees.map((emp, i) => (
//                     <tr key={i}>
//                       <td>{emp.name}</td>
//                       <td>{emp.unit}</td>
//                       <td>
//                         <select
//                           className="type-dropdown"
//                           value={tempEmployeeTypes[i] || ""}
//                           onChange={(e) => {
//                             const updated = {
//                               ...tempEmployeeTypes,
//                               [i]: e.target.value
//                             };
//                             setTempEmployeeTypes(updated);
//                           }}
//                         >
//                           <option value="">Select</option>
//                           <option value="1">Type1</option>
//                           <option value="2">Type2</option>
//                           <option value="3">Type3</option>
//                           <option value="4">Type4</option>
//                           <option value="5">Type5</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="no-data">
//                       No leave records
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* 🔥 APPLY BUTTON (added below table) */}
//             <div className="modal-footer">
//               <button
//                 className="apply-btn"
//                 onClick={() => {
//                   setEmployeeTypes(tempEmployeeTypes);
//                   setShowLeaveModal(false);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import Select from "react-select";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);
//   const [employeeTypes, setEmployeeTypes] = useState({});
//   const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
//   const [headcountErrors, setHeadcountErrors] = useState({});

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });


//   const departmentOptions = [
//   { value: "FI Design", label: "FI Design" },
//   { value: "FSPLO", label: "FSPLO" },
//   { value: "LTDM PC", label: "LTDM PC" },
//   { value: "DDI", label: "DDI" },
//   { value: "DMS", label: "DMS" },
//   { value: "FI-IE", label: "FI-IE" },
//   { value: "LTO", label: "LTO" }
// ];

// const monthOptions = [
//   { value: "Jan", label: "Jan" },
//   { value: "Feb", label: "Feb" },
//   { value: "Mar", label: "Mar" },
//   { value: "Apr", label: "Apr" },
//   { value: "May", label: "May" },
//   { value: "Jun", label: "Jun" },
//   { value: "Jul", label: "Jul" },
//   { value: "Aug", label: "Aug" },
//   { value: "Sep", label: "Sep" },
//   { value: "Oct", label: "Oct" },
//   { value: "Nov", label: "Nov" },
//   { value: "Dec", label: "Dec" }
// ];

// const yearOptions = [
//   { value: "2026", label: "2026" },
//   { value: "2027", label: "2027" }
// ];

//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;
//     if (!leaveEmployees.length) return; // ✅ ADD THIS

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);

//     // 🔥 ALWAYS START FROM BASE
//     let updatedItems = lineItems.map((item) => {
//       const headcount = Number(item.headcount || 0);
//       const baseTWHM = headcount * hoursPerDay * workingDays;

//       return {
//         ...item,
//         hours: baseTWHM
//       };
//     });

//     // 🔥 GROUP
//     const typeTotals = {};

//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       const emp = leaveEmployees[empIndex];

//       if (!type || !emp) return;

//       if (!typeTotals[type]) {
//         typeTotals[type] = 0;
//       }

//       typeTotals[type] += Number(emp.unit || 0);
//     });

//     // 🔥 APPLY ONCE
//     Object.keys(typeTotals).forEach((type) => {
//       const rowIndex = Number(type) - 1;

//       if (!updatedItems[rowIndex]) return;

//       const totalUnits = typeTotals[type];

//       updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveLoading,
//     employeeTypes,
//     leaveEmployees
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   useEffect(() => {
//     if (!form.month || !form.year) return;

//     const monthIndexMap = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     };

//     const monthIndex = monthIndexMap[form.month];
//     const year = Number(form.year);

//     const lastDay = new Date(year, monthIndex + 1, 0).getDate();

//     const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;

//     setForm(prev => {
//       if (prev.serviceDate === formattedDate) return prev;

//       return {
//         ...prev,
//         serviceDate: formattedDate
//       };
//     });

//   }, [form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);

//     // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
//     if (name === "headcount") {
//       const type = index + 1; // row1 → Type1

//       let selectedCount = 0;

//       // count employees selected for this type
//       Object.keys(employeeTypes).forEach((empIndex) => {
//         if (Number(employeeTypes[empIndex]) === type) {
//           selectedCount++;
//         }
//       });

//       const enteredHeadcount = Number(value || 0);

//       setHeadcountErrors(prev => ({
//         ...prev,
//         [index]:
//           enteredHeadcount < selectedCount
//             ? `Minimum ${selectedCount} required`
//             : ""
//       }));
//     }
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       {
//         rate: "",
//         headcount: "",
//         hours: 0,
//         auto: false
//       }
//     ]);
//   };

//   const deleteLineItem = (index) => {
//     setLineItems(prev => prev.filter((_, i) => i !== index));
//   };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const validateHeadcount = () => {
//     const typeCounts = {};

//     // count employees per type
//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       if (!type) return;

//       if (!typeCounts[type]) {
//         typeCounts[type] = 0;
//       }

//       typeCounts[type]++;
//     });

//     // validate against lineItems
//     for (let type in typeCounts) {
//       const rowIndex = Number(type) - 1;

//       const selectedEmployees = typeCounts[type];
//       const headcount = Number(lineItems[rowIndex]?.headcount || 0);

//       if (headcount < selectedEmployees) {
//         alert(
//           `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
//         );
//         return false;
//       }
//     }

//     return true;
//   };

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };

//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         {/* HEADER FILTERS */}
// <div className="header-bar">

//   <div className="filter-group department-filter">
//     <select
//       name="department"
//       value={form.department || ""}
//       onChange={handleChange}
//     >
//       <option value="">Department</option>
//       <option value="FI Design">FI Design</option>
//       <option value="FSPLO">FSPLO</option>
//       <option value="LTDM PC">LTDM PC</option>
//       <option value="DDI">DDI</option>
//       <option value="DMS">DMS</option>
//       <option value="FI-IE">FI-IE</option>
//       <option value="LTO">LTO</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="month"
//       value={form.month || ""}
//       onChange={handleChange}
//     >
//       <option value="">Month</option>
//       <option value="Jan">Jan</option>
//       <option value="Feb">Feb</option>
//       <option value="Mar">Mar</option>
//       <option value="Apr">Apr</option>
//       <option value="May">May</option>
//       <option value="Jun">Jun</option>
//       <option value="Jul">Jul</option>
//       <option value="Aug">Aug</option>
//       <option value="Sep">Sep</option>
//       <option value="Oct">Oct</option>
//       <option value="Nov">Nov</option>
//       <option value="Dec">Dec</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="year"
//       value={form.year || ""}
//       onChange={handleChange}
//     >
//       <option value="">Year</option>
//       <option value="2026">2026</option>
//       <option value="2027">2027</option>
//     </select>
//   </div>

// </div>

        

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>

//                     {/* TOP RIGHT DELETE ICON */}
//                     <span
//                       className="delete-icon"
//                       onClick={() => deleteLineItem(index)}
//                     >
//                       ✖
//                     </span>

//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>

//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                         className={headcountErrors[index] ? "input-error" : ""}
//                       />

//                       {headcountErrors[index] && (
//                         <div className="error-text">
//                           {headcountErrors[index]}
//                         </div>
//                       )}
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div> */}



//             </div>
//             <div className="row">
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Total Amount</label>

//                 <div className="currency-input">
//                   <span className="currency-symbol">$</span>

//                   <input
//                     name="total"
//                     value={form.total !== "" ? form.total : calculateTotal()}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div> */}

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//       {showLeaveModal && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//         >
//           <div
//             className="modal-box large-modal"
//             onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//           >

//             {/* HEADER */}
//             <div className="modal-header">
//               <h3>Leave Details</h3>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowLeaveModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             {/* TABLE */}
//             <table className="leave-table big-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Unit</th>
//                   <th>Type</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {leaveEmployees.length > 0 ? (
//                   leaveEmployees.map((emp, i) => (
//                     <tr key={i}>
//                       <td>{emp.name}</td>
//                       <td>{emp.unit}</td>
//                       <td>
//                         <select
//                           className="type-dropdown"
//                           value={tempEmployeeTypes[i] || ""}
//                           onChange={(e) => {
//                             const updated = {
//                               ...tempEmployeeTypes,
//                               [i]: e.target.value
//                             };
//                             setTempEmployeeTypes(updated);
//                           }}
//                         >
//                           <option value="">Select</option>
//                           <option value="1">Type1</option>
//                           <option value="2">Type2</option>
//                           <option value="3">Type3</option>
//                           <option value="4">Type4</option>
//                           <option value="5">Type5</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="no-data">
//                       No leave records
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* 🔥 APPLY BUTTON (added below table) */}
//             <div className="modal-footer">
//               <button
//                 className="apply-btn"
//                 onClick={() => {
//                   setEmployeeTypes(tempEmployeeTypes);
//                   setShowLeaveModal(false);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }




























// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import Select from "react-select";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);
//   const [employeeTypes, setEmployeeTypes] = useState({});
//   const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
//   const [headcountErrors, setHeadcountErrors] = useState({});

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });


//   const departmentOptions = [
//   { value: "FI Design", label: "FI Design" },
//   { value: "FSPLO", label: "FSPLO" },
//   { value: "LTDM PC", label: "LTDM PC" },
//   { value: "DDI", label: "DDI" },
//   { value: "DMS", label: "DMS" },
//   { value: "FI-IE", label: "FI-IE" },
//   { value: "LTO", label: "LTO" }
// ];

// const monthOptions = [
//   { value: "Jan", label: "Jan" },
//   { value: "Feb", label: "Feb" },
//   { value: "Mar", label: "Mar" },
//   { value: "Apr", label: "Apr" },
//   { value: "May", label: "May" },
//   { value: "Jun", label: "Jun" },
//   { value: "Jul", label: "Jul" },
//   { value: "Aug", label: "Aug" },
//   { value: "Sep", label: "Sep" },
//   { value: "Oct", label: "Oct" },
//   { value: "Nov", label: "Nov" },
//   { value: "Dec", label: "Dec" }
// ];

// const yearOptions = [
//   { value: "2026", label: "2026" },
//   { value: "2027", label: "2027" }
// ];

//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;
//     if (!leaveEmployees.length) return; // ✅ ADD THIS

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);

//     // 🔥 ALWAYS START FROM BASE
//     let updatedItems = lineItems.map((item) => {
//       const headcount = Number(item.headcount || 0);
//       const baseTWHM = headcount * hoursPerDay * workingDays;

//       return {
//         ...item,
//         hours: baseTWHM
//       };
//     });

//     // 🔥 GROUP
//     const typeTotals = {};

//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       const emp = leaveEmployees[empIndex];

//       if (!type || !emp) return;

//       if (!typeTotals[type]) {
//         typeTotals[type] = 0;
//       }

//       typeTotals[type] += Number(emp.unit || 0);
//     });

//     // 🔥 APPLY ONCE
//     Object.keys(typeTotals).forEach((type) => {
//       const rowIndex = Number(type) - 1;

//       if (!updatedItems[rowIndex]) return;

//       const totalUnits = typeTotals[type];

//       updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveLoading,
//     employeeTypes,
//     leaveEmployees
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   useEffect(() => {
//     if (!form.month || !form.year) return;

//     const monthIndexMap = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     };

//     const monthIndex = monthIndexMap[form.month];
//     const year = Number(form.year);

//     const lastDay = new Date(year, monthIndex + 1, 0).getDate();

//     const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;

//     setForm(prev => {
//       if (prev.serviceDate === formattedDate) return prev;

//       return {
//         ...prev,
//         serviceDate: formattedDate
//       };
//     });

//   }, [form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);

//     // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
//     if (name === "headcount") {
//       const type = index + 1; // row1 → Type1

//       let selectedCount = 0;

//       // count employees selected for this type
//       Object.keys(employeeTypes).forEach((empIndex) => {
//         if (Number(employeeTypes[empIndex]) === type) {
//           selectedCount++;
//         }
//       });

//       const enteredHeadcount = Number(value || 0);

//       setHeadcountErrors(prev => ({
//         ...prev,
//         [index]:
//           enteredHeadcount < selectedCount
//             ? `Minimum ${selectedCount} required`
//             : ""
//       }));
//     }
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       {
//         rate: "",
//         headcount: "",
//         hours: 0,
//         auto: false
//       }
//     ]);
//   };

//   const deleteLineItem = (index) => {
//     setLineItems(prev => prev.filter((_, i) => i !== index));
//   };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     // const date = form.serviceDate || "";
//     const invoiceDate = form.serviceDate
//   ? new Date(form.serviceDate).toLocaleDateString("en-GB", {
//       day: "numeric",
//       month: "long",
//       year: "numeric"
//     })
//   : "";


//   const serviceMonth = form.month && form.year
//   ? `${{
//       Jan: "January",
//       Feb: "February",
//       Mar: "March",
//       Apr: "April",
//       May: "May",
//       Jun: "June",
//       Jul: "July",
//       Aug: "August",
//       Sep: "September",
//       Oct: "October",
//       Nov: "November",
//       Dec: "December"
//     }[form.month]} ${form.year}`
//   : "";

//     const total = calculateTotal();

//     // page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(invoiceDate, {
//   x: 204.5,
//   y: 595,
//   size: 10,
//   font
// });
//     // page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date
//     page.drawText(serviceMonth, {
//   x: 204.5,
//   y: 581,
//   size: 10,
//   font
// });

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };


//   useEffect(() => {
//     const updatePreview = async () => {
//       const bytes = await generatePDF();
//       const blob = new Blob([bytes], { type: "application/pdf" });
//       const url = URL.createObjectURL(blob);
//       setPreviewUrl(url);
//     };

//     updatePreview();
//   }, [form]);

//   const validateHeadcount = () => {
//     const typeCounts = {};

//     // count employees per type
//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       if (!type) return;

//       if (!typeCounts[type]) {
//         typeCounts[type] = 0;
//       }

//       typeCounts[type]++;
//     });

//     // validate against lineItems
//     for (let type in typeCounts) {
//       const rowIndex = Number(type) - 1;

//       const selectedEmployees = typeCounts[type];
//       const headcount = Number(lineItems[rowIndex]?.headcount || 0);

//       if (headcount < selectedEmployees) {
//         alert(
//           `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
//         );
//         return false;
//       }
//     }

//     return true;
//   };

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };

//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         {/* HEADER FILTERS */}
// <div className="header-bar">

//   <div className="filter-group department-filter">
//     <select
//       name="department"
//       value={form.department || ""}
//       onChange={handleChange}
//     >
//       <option value="">Department</option>
//       <option value="FI Design">FI Design</option>
//       <option value="FSPLO">FSPLO</option>
//       <option value="LTDM PC">LTDM PC</option>
//       <option value="DDI">DDI</option>
//       <option value="DMS">DMS</option>
//       <option value="FI-IE">FI-IE</option>
//       <option value="LTO">LTO</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="month"
//       value={form.month || ""}
//       onChange={handleChange}
//     >
//       <option value="">Month</option>
//       <option value="Jan">Jan</option>
//       <option value="Feb">Feb</option>
//       <option value="Mar">Mar</option>
//       <option value="Apr">Apr</option>
//       <option value="May">May</option>
//       <option value="Jun">Jun</option>
//       <option value="Jul">Jul</option>
//       <option value="Aug">Aug</option>
//       <option value="Sep">Sep</option>
//       <option value="Oct">Oct</option>
//       <option value="Nov">Nov</option>
//       <option value="Dec">Dec</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="year"
//       value={form.year || ""}
//       onChange={handleChange}
//     >
//       <option value="">Year</option>
//       <option value="2026">2026</option>
//       <option value="2027">2027</option>
//     </select>
//   </div>

// </div>

        

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>

//                     {/* TOP RIGHT DELETE ICON */}
//                     <span
//                       className="delete-icon"
//                       onClick={() => deleteLineItem(index)}
//                     >
//                       ✖
//                     </span>

//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>

//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                         className={headcountErrors[index] ? "input-error" : ""}
//                       />

//                       {headcountErrors[index] && (
//                         <div className="error-text">
//                           {headcountErrors[index]}
//                         </div>
//                       )}
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div> */}



//             </div>
//             <div className="row">
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Total Amount</label>

//                 <div className="currency-input">
//                   <span className="currency-symbol">$</span>

//                   <input
//                     name="total"
//                     value={form.total !== "" ? form.total : calculateTotal()}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div> */}

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//       {showLeaveModal && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//         >
//           <div
//             className="modal-box large-modal"
//             onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//           >

//             {/* HEADER */}
//             <div className="modal-header">
//               <h3>Leave Details</h3>
//               <button
//                 className="close-btn"
//                 onClick={() => setShowLeaveModal(false)}
//               >
//                 ✕
//               </button>
//             </div>

//             {/* TABLE */}
//             <table className="leave-table big-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Unit</th>
//                   <th>Type</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {leaveEmployees.length > 0 ? (
//                   leaveEmployees.map((emp, i) => (
//                     <tr key={i}>
//                       <td>{emp.name}</td>
//                       <td>{emp.unit}</td>
//                       <td>
//                         <select
//                           className="type-dropdown"
//                           value={tempEmployeeTypes[i] || ""}
//                           onChange={(e) => {
//                             const updated = {
//                               ...tempEmployeeTypes,
//                               [i]: e.target.value
//                             };
//                             setTempEmployeeTypes(updated);
//                           }}
//                         >
//                           <option value="">Select</option>
//                           <option value="1">Type1</option>
//                           <option value="2">Type2</option>
//                           <option value="3">Type3</option>
//                           <option value="4">Type4</option>
//                           <option value="5">Type5</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="no-data">
//                       No leave records
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* 🔥 APPLY BUTTON (added below table) */}
//             <div className="modal-footer">
//               <button
//                 className="apply-btn"
//                 onClick={() => {
//                   setEmployeeTypes(tempEmployeeTypes);
//                   setShowLeaveModal(false);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }






















// import React, { useState, useEffect } from "react";
// import { PDFDocument, StandardFonts } from "pdf-lib";
// import Select from "react-select";
// import "../styles/Invoice.css";

// export default function InvoiceGenerator() {

//   const [showLeaveModal, setShowLeaveModal] = useState(false);
//   const [leaveEmployees, setLeaveEmployees] = useState([]);
//   const [employeeTypes, setEmployeeTypes] = useState({});
//   const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
//   const [headcountErrors, setHeadcountErrors] = useState({});

//   const [lineItems, setLineItems] = useState([
//     { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
//   ]);

//   const [form, setForm] = useState({
//     department: "",
//     month: "",
//     year: "",
//     serviceDate: "",
//     buyer: "Intel Corporation",
//     address: "Hillsboro, Oregon",
//     country: "USA",
//     total: ""
//   });


//   const departmentOptions = [
//   { value: "FI Design", label: "FI Design" },
//   { value: "FSPLO", label: "FSPLO" },
//   { value: "LTDM PC", label: "LTDM PC" },
//   { value: "DDI", label: "DDI" },
//   { value: "DMS", label: "DMS" },
//   { value: "FI-IE", label: "FI-IE" },
//   { value: "LTO", label: "LTO" }
// ];

// const monthOptions = [
//   { value: "Jan", label: "Jan" },
//   { value: "Feb", label: "Feb" },
//   { value: "Mar", label: "Mar" },
//   { value: "Apr", label: "Apr" },
//   { value: "May", label: "May" },
//   { value: "Jun", label: "Jun" },
//   { value: "Jul", label: "Jul" },
//   { value: "Aug", label: "Aug" },
//   { value: "Sep", label: "Sep" },
//   { value: "Oct", label: "Oct" },
//   { value: "Nov", label: "Nov" },
//   { value: "Dec", label: "Dec" }
// ];

// const yearOptions = [
//   { value: "2026", label: "2026" },
//   { value: "2027", label: "2027" }
// ];

//   const [leaveLoading, setLeaveLoading] = useState(false);
//   const [previewUrl, setPreviewUrl] = useState(null);

//   const [leaveDeduction, setLeaveDeduction] = useState({
//     days: 0,
//     hours: 0
//   });


//   const fetchLeaveEmployees = async () => {
//     try {
//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveEmployees(data.employees);
//       } else {
//         setLeaveEmployees([]);
//       }

//     } catch (err) {
//       console.error(err);
//       setLeaveEmployees([]);
//     }
//   };




//   const fetchLeavesForInvoice = async () => {
//     try {
//       setLeaveLoading(true); // ✅ START LOADING

//       const monthMap = {
//         Jan: 1, Feb: 2, Mar: 3, Apr: 4,
//         May: 5, Jun: 6, Jul: 7, Aug: 8,
//         Sep: 9, Oct: 10, Nov: 11, Dec: 12
//       };

//       const res = await fetch(
//         `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
//       );

//       const data = await res.json();

//       if (data.success) {
//         setLeaveDeduction({
//           days: data.days,
//           hours: data.hours
//         });
//       } else {
//         setLeaveDeduction({ days: 0, hours: 0 });
//       }

//     } catch (err) {
//       console.error("Leave API error", err);
//       setLeaveDeduction({ days: 0, hours: 0 });
//     } finally {
//       setLeaveLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!form.headcount || !form.month || !form.year) return;

//     // ❌ WAIT until API is done
//     if (leaveLoading) return;

//     const hoursPerDay = 8;

//     const workingDays = getWorkingDays(form.month, form.year);

//     const headcount = Number(form.headcount) || 0;

//     const baseTWHM = headcount * hoursPerDay * workingDays;

//     const deductionHours = Number(leaveDeduction.hours) || 0;

//     const finalTWHM = baseTWHM - deductionHours;

//     setForm(prev => {
//       if (prev.hours === finalTWHM) return prev;

//       return {
//         ...prev,
//         hours: Math.max(0, finalTWHM)
//       };
//     });

//   }, [
//     form.headcount,
//     form.month,
//     form.year,
//     leaveDeduction.hours,
//     leaveLoading   // ✅ IMPORTANT
//   ]);

//   // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

//   useEffect(() => {
//     if (!form.month || !form.year) return;
//     if (leaveLoading) return;
//     if (!leaveEmployees.length) return; // ✅ ADD THIS

//     const hoursPerDay = 8;
//     const workingDays = getWorkingDays(form.month, form.year);

//     // 🔥 ALWAYS START FROM BASE
//     let updatedItems = lineItems.map((item) => {
//       const headcount = Number(item.headcount || 0);
//       const baseTWHM = headcount * hoursPerDay * workingDays;

//       return {
//         ...item,
//         hours: baseTWHM
//       };
//     });

//     // 🔥 GROUP
//     const typeTotals = {};

//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       const emp = leaveEmployees[empIndex];

//       if (!type || !emp) return;

//       if (!typeTotals[type]) {
//         typeTotals[type] = 0;
//       }

//       typeTotals[type] += Number(emp.unit || 0);
//     });

//     // 🔥 APPLY ONCE
//     Object.keys(typeTotals).forEach((type) => {
//       const rowIndex = Number(type) - 1;

//       if (!updatedItems[rowIndex]) return;

//       const totalUnits = typeTotals[type];

//       updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
//     });

//     setLineItems(updatedItems);

//   }, [
//     lineItems.map(i => i.headcount).join(),
//     form.month,
//     form.year,
//     leaveLoading,
//     employeeTypes,
//     leaveEmployees
//   ]);

//   useEffect(() => {
//     console.log("TRIGGER CHECK:", form);

//     if (form.department && form.month && form.year) {
//       console.log("CALLING API 🚀");
//       fetchLeavesForInvoice();
//     }
//   }, [form.department, form.month, form.year]);

//   useEffect(() => {
//     if (!form.month || !form.year) return;

//     const monthIndexMap = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     };

//     const monthIndex = monthIndexMap[form.month];
//     const year = Number(form.year);

//     const lastDay = new Date(year, monthIndex + 1, 0).getDate();

//     const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;

//     setForm(prev => {
//       if (prev.serviceDate === formattedDate) return prev;

//       return {
//         ...prev,
//         serviceDate: formattedDate
//       };
//     });

//   }, [form.month, form.year]);

//   const [invoiceNo, setInvoiceNo] = useState(1);

//   function getFinancialYear(month, year) {
//     if (!month || !year) return "";

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let startYear, endYear;

//     if (monthIndex >= 3) { // April onwards
//       startYear = year;
//       endYear = Number(year) + 1;
//     } else {
//       startYear = Number(year) - 1;
//       endYear = year;
//     }

//     return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
//   }

//   useEffect(() => {
//     const fy = getFinancialYear(form.month, form.year);
//     if (!fy) return;

//     const stored = localStorage.getItem(`invoice-${fy}`);
//     setInvoiceNo(stored ? Number(stored) : 1);
//   }, [form.month, form.year]);



//   function getWorkingDays(month, year) {
//     if (!month || !year) return 0;

//     const monthIndex = {
//       Jan: 0, Feb: 1, Mar: 2, Apr: 3,
//       May: 4, Jun: 5, Jul: 6, Aug: 7,
//       Sep: 8, Oct: 9, Nov: 10, Dec: 11
//     }[month];

//     let count = 0;
//     const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

//     for (let d = 1; d <= daysInMonth; d++) {
//       const day = new Date(year, monthIndex, d).getDay();
//       if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
//     }

//     return count;
//   }
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm(prev => {
//       let updatedForm = { ...prev, [name]: value };

//       const hoursPerDay = 8;

//       const workingDays = getWorkingDays(
//         name === "month" ? value : updatedForm.month,
//         name === "year" ? value : updatedForm.year
//       );

//       // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
//       if (
//         name === "headcount" ||
//         name === "month" ||
//         name === "year"
//       ) {
//         const headcount = Number(
//           name === "headcount" ? value : updatedForm.headcount
//         ) || 0;
//       }

//       // ✅ AUTO-FILL SERVICE DATE
//       if (name === "invoiceDate") {
//         if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
//           updatedForm.serviceDate = value;
//         }
//       }

//       return updatedForm;
//     });
//   };

//   const handleLineChange = (index, e) => {
//     const { name, value } = e.target;

//     const updated = [...lineItems];
//     updated[index][name] = value;

//     setLineItems(updated);

//     // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
//     if (name === "headcount") {
//       const type = index + 1; // row1 → Type1

//       let selectedCount = 0;

//       // count employees selected for this type
//       Object.keys(employeeTypes).forEach((empIndex) => {
//         if (Number(employeeTypes[empIndex]) === type) {
//           selectedCount++;
//         }
//       });

//       const enteredHeadcount = Number(value || 0);

//       setHeadcountErrors(prev => ({
//         ...prev,
//         [index]:
//           enteredHeadcount < selectedCount
//             ? `Minimum ${selectedCount} required`
//             : ""
//       }));
//     }
//   };

//   const addLineItem = () => {
//     setLineItems(prev => [
//       ...prev,
//       {
//         rate: "",
//         headcount: "",
//         hours: 0,
//         auto: false
//       }
//     ]);
//   };

//   const deleteLineItem = (index) => {
//     setLineItems(prev => prev.filter((_, i) => i !== index));
//   };


//   const calculateTotal = () => {
//     if (form.total !== "") {
//       return Number(form.total) || 0;
//     }

//     return lineItems.reduce((sum, item) => {
//       return sum + (Number(item.rate) * Number(item.hours));
//     }, 0);
//   };

//   // 🔥 form fields
//   // 🔥 remove total
//   const { total, ...restForm } = form;

//   // 🔥 form fields
//   const formFields = Object.values(restForm);

//   // 🔥 line items
//   const lineItemFields = lineItems.flatMap(item => [
//     item.rate,
//     item.headcount,
//     item.hours
//   ]);

//   // 🔥 combine
//   const allFields = [...formFields, ...lineItemFields];

//   // 🔥 count
//   const filled = allFields.filter(v => v !== "" && v !== null).length;

//   // 🔥 %
//   const progress = Math.round((filled / allFields.length) * 100);

//   const isComplete = progress === 100;

//   function numberToWords(num) {
//     if (num === 0) return "Zero Dollars Only";

//     const ones = [
//       "", "One", "Two", "Three", "Four", "Five", "Six",
//       "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
//       "Thirteen", "Fourteen", "Fifteen", "Sixteen",
//       "Seventeen", "Eighteen", "Nineteen"
//     ];

//     const tens = [
//       "", "", "Twenty", "Thirty", "Forty", "Fifty",
//       "Sixty", "Seventy", "Eighty", "Ninety"
//     ];

//     const thousands = ["", "Thousand", "Million", "Billion"];

//     function convertHundreds(n) {
//       let str = "";

//       if (n > 99) {
//         str += ones[Math.floor(n / 100)] + " Hundred ";
//         n %= 100;
//       }

//       if (n > 19) {
//         str += tens[Math.floor(n / 10)] + " ";
//         n %= 10;
//       }

//       if (n > 0) {
//         str += ones[n] + " ";
//       }

//       return str.trim();
//     }

//     let word = "";
//     let i = 0;

//     while (num > 0) {
//       if (num % 1000 !== 0) {
//         word =
//           convertHundreds(num % 1000) +
//           " " +
//           thousands[i] +
//           " " +
//           word;
//       }
//       num = Math.floor(num / 1000);
//       i++;
//     }

//     return word.trim() + " Dollars Only";
//   }

//   // 🔥 Generate PDF
//   const generatePDF = async () => {
//     const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
//       .then(res => res.arrayBuffer());

//     const pdfDoc = await PDFDocument.load(existingPdfBytes);
//     const page = pdfDoc.getPages()[0];

//     const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
//     const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
//     const fy = getFinancialYear(form.month, form.year);

//     const date = form.serviceDate || "";

//     const total = calculateTotal();

//     page.drawText(date, { x: 204.5, y: 595, size: 10, font }); // Invoice Date
//     page.drawText(date, { x: 204.5, y: 581, size: 10, font }); // Service Date

//     page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
//     page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
//     page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

//     page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
//     page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
//     page.drawText(`$${total}`, {
//       x: 455,
//       y: 315.5,
//       size: 10,
//       font: boldFont
//     });

//     page.drawText(numberToWords(total), {
//       x: 204,
//       y: 235,
//       size: 10,
//       font: boldFont
//     });


//     page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
//       x: 204.5,
//       y: 565,
//       size: 10,
//       font
//     });

//     return await pdfDoc.save();
//   };

// useEffect(() => {
//   const updatePreview = async () => {
//     const bytes = await generatePDF();

//     const blob = new Blob(
//       [bytes],
//       { type: "application/pdf" }
//     );

//     const url = URL.createObjectURL(blob);

//     setPreviewUrl(prev => {
//       if (prev) URL.revokeObjectURL(prev);
//       return url;
//     });
//   };

//   updatePreview();

// }, [
//   form,
//   lineItems,
//   invoiceNo
// ]);

//   const validateHeadcount = () => {
//     const typeCounts = {};

//     // count employees per type
//     Object.keys(employeeTypes).forEach((empIndex) => {
//       const type = Number(employeeTypes[empIndex]);
//       if (!type) return;

//       if (!typeCounts[type]) {
//         typeCounts[type] = 0;
//       }

//       typeCounts[type]++;
//     });

//     // validate against lineItems
//     for (let type in typeCounts) {
//       const rowIndex = Number(type) - 1;

//       const selectedEmployees = typeCounts[type];
//       const headcount = Number(lineItems[rowIndex]?.headcount || 0);

//       if (headcount < selectedEmployees) {
//         alert(
//           `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
//         );
//         return false;
//       }
//     }

//     return true;
//   };

//   const downloadPDF = async () => {
//     const bytes = await generatePDF();
//     const blob = new Blob([bytes], { type: "application/pdf" });

//     const fy = getFinancialYear(form.month, form.year);

//     const a = document.createElement("a");
//     a.href = URL.createObjectURL(blob);
//     a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
//     a.click();

//     const next = invoiceNo + 1;

//     localStorage.setItem(`invoice-${fy}`, next);
//     setInvoiceNo(next);
//   };

//   return (
//     <div className="main-container">

//       {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
//       <div className="page-content">

//         {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
//         {/* HEADER FILTERS */}
// <div className="header-bar">

//   <div className="filter-group department-filter">
//     <select
//       name="department"
//       value={form.department || ""}
//       onChange={handleChange}
//     >
//       <option value="">Department</option>
//       <option value="FI Design">FI Design</option>
//       <option value="FSPLO">FSPLO</option>
//       <option value="LTDM PC">LTDM PC</option>
//       <option value="DDI">DDI</option>
//       <option value="DMS">DMS</option>
//       <option value="FI-IE">FI-IE</option>
//       <option value="LTO">LTO</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="month"
//       value={form.month || ""}
//       onChange={handleChange}
//     >
//       <option value="">Month</option>
//       <option value="Jan">Jan</option>
//       <option value="Feb">Feb</option>
//       <option value="Mar">Mar</option>
//       <option value="Apr">Apr</option>
//       <option value="May">May</option>
//       <option value="Jun">Jun</option>
//       <option value="Jul">Jul</option>
//       <option value="Aug">Aug</option>
//       <option value="Sep">Sep</option>
//       <option value="Oct">Oct</option>
//       <option value="Nov">Nov</option>
//       <option value="Dec">Dec</option>
//     </select>
//   </div>

//   <div className="filter-group">
//     <select
//       name="year"
//       value={form.year || ""}
//       onChange={handleChange}
//     >
//       <option value="">Year</option>
//       <option value="2026">2026</option>
//       <option value="2027">2027</option>
//     </select>
//   </div>

// </div>

        

//         {/* 🔽 BELOW HEADER */}
//         <div className="content-area">

//           {/* LEFT */}
//           <div className="form-section">



//             <div className="invoice-header">
//               <h2>⚡ Create Invoice</h2>

//               {/* 🔥 NEW ROW */}
//               <div className="invoice-row">

//                 <div className="invoice-no-box">
//                   <span>
//                     GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
//                   </span>

//                   <div className="invoice-controls">
//                     <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
//                     <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
//                   </div>
//                 </div>

//                 <div className="metrics-row">
//                   <div className="metric-card working-days-card">
//                     <div className="metric-title">WORKING DAYS</div>
//                     <div className="metric-value">
//                       {getWorkingDays(form.month, form.year)}
//                     </div>
//                   </div>

//                   <div className="metric-card deduction-card">

//                     <div className="metric-title">
//                       DEDUCTION
//                       <span
//                         className="info-icon"
//                         title="View leave details"
//                         onClick={() => {
//                           fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
//                           setShowLeaveModal(true); // 🔥 open popup
//                         }}
//                       >
//                         ⓘ
//                       </span>
//                     </div>

//                     {leaveLoading ? (
//                       <div className="metric-note">Calculating...</div>
//                     ) : leaveDeduction.days > 0 ? (
//                       <div className="metric-note">
//                         ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
//                       </div>
//                     ) : (
//                       <div className="metric-note success">
//                         No deductions
//                       </div>
//                     )}

//                   </div>


//                 </div>

//               </div>
//             </div>

//             <div className="form-grid">

//               {/* ADD BUTTON */}
//               <button className="add-btn" type="button" onClick={addLineItem}>
//                 + Add Line Item
//               </button>

//               {/* LINE ITEMS */}
//               <div className="line-items">
//                 {lineItems.map((item, index) => (
//                   <div className="row" key={index}>

//                     {/* TOP RIGHT DELETE ICON */}
//                     <span
//                       className="delete-icon"
//                       onClick={() => deleteLineItem(index)}
//                     >
//                       ✖
//                     </span>

//                     <div className="field">
//                       <label>Rate</label>
//                       <input
//                         name="rate"
//                         value={item.rate}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                     <div className="field">
//                       <label>Headcount</label>

//                       <input
//                         name="headcount"
//                         value={item.headcount}
//                         onChange={(e) => handleLineChange(index, e)}
//                         className={headcountErrors[index] ? "input-error" : ""}
//                       />

//                       {headcountErrors[index] && (
//                         <div className="error-text">
//                           {headcountErrors[index]}
//                         </div>
//                       )}
//                     </div>

//                     <div className="field">
//                       <label>TWHM</label>
//                       <input
//                         name="hours"
//                         value={item.hours}
//                         onChange={(e) => handleLineChange(index, e)}
//                       />
//                     </div>

//                   </div>
//                 ))}
//               </div>

//               {/* DIVIDER */}
//               <div className="divider"></div>

//               {/* STATIC SECTION */}
//               <div className="row">
//                 <div className="field">
//                   <label>Name of the Buyer</label>
//                   <input name="buyer" value={form.buyer} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Address</label>
//                   <input name="address" value={form.address} onChange={handleChange} />
//                 </div>

//                 <div className="field">
//                   <label>Country Name</label>
//                   <input name="country" value={form.country} onChange={handleChange} />
//                 </div>
//               </div>

//               {/* <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div> */}



//             </div>
//             <div className="row">
//               <div className="field">
//                 <label>Date (Invoice & Service)</label>
//                 <input
//                   type="date"
//                   name="serviceDate"
//                   value={form.serviceDate}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="field">
//                 <label>Total Amount</label>

//                 <div className="currency-input">
//                   <span className="currency-symbol">$</span>

//                   <input
//                     name="total"
//                     value={form.total !== "" ? form.total : calculateTotal()}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>
//             </div>
//             {/* <div className="total-box">
//               <span>Total Amount</span>

//               <input
//                 name="total"
//                 value={form.total !== "" ? form.total : calculateTotal()}
//                 onChange={handleChange}
//                 className="total-input"
//               />
//             </div> */}

//             <div className="progress-wrapper bottom-progress">
//               <div className="progress-bar">
//                 <div style={{ width: `${progress}%` }} />
//               </div>
//               <br />
//               <div className="btn-wrapper">
//                 <button
//                   disabled={!isComplete}
//                   className={isComplete ? "btn-active" : "btn-disabled"}
//                   onClick={downloadPDF}
//                 >
//                   Generate PDF
//                 </button>
//               </div>
//             </div>
//             <br />

//           </div>





//           {/* RIGHT */}
//           <div className="preview-section">
//             <div className="preview-card">
//               <center>
//                 <div className="preview-header">Live Invoice Preview</div>
//               </center>
//               {previewUrl ? (

//                 <iframe
//                   src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
//                   title="preview"
//                 />


//               ) :
//                 (
//                   <p style={{ color: "#64748b" }}>Fill details to preview</p>
//                 )
//               }
//             </div>
//           </div>

//         </div>

//       </div>
//       {showLeaveModal && (
//         <div
//           className="inv-modal-overlay"
//           onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
//         >
//           <div
//             className="inv-modal-box"
//             onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
//           >
//             <button
//               className="inv-modal-close-btn"
//               onClick={() => setShowLeaveModal(false)}
//             >
//               ✕
//             </button>

//             {/* HEADER */}
//             <div className="inv-modal-header">
//               <div>
//                 <h3>Leave Details</h3>
//                 <p className="inv-modal-subtitle">Review employee leave details and classify them into respective invoice types.</p>
//               </div>
//             </div>

//             {/* TABLE */}
//             <table className="inv-leave-table">
//               <thead>
//                 <tr>
//                   <th>Name</th>
//                   <th>Unit</th>
//                   <th>Type</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {leaveEmployees.length > 0 ? (
//                   leaveEmployees.map((emp, i) => (
//                     <tr key={i}>
//                       <td>{emp.name}</td>
//                       <td>{emp.unit}</td>
//                       <td>
//                         <select
//                           className="inv-type-dropdown"
//                           value={tempEmployeeTypes[i] || ""}
//                           onChange={(e) => {
//                             const updated = {
//                               ...tempEmployeeTypes,
//                               [i]: e.target.value
//                             };
//                             setTempEmployeeTypes(updated);
//                           }}
//                         >
//                           <option value="">Select</option>
//                           <option value="1">Type1</option>
//                           <option value="2">Type2</option>
//                           <option value="3">Type3</option>
//                           <option value="4">Type4</option>
//                           <option value="5">Type5</option>
//                         </select>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="3" className="no-data">
//                       No leave records
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {/* 🔥 BUTTONS */}
//             <div className="inv-modal-footer">
//               <button
//                 className="inv-cancel-btn"
//                 onClick={() => setShowLeaveModal(false)}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="inv-apply-btn"
//                 onClick={() => {
//                   setEmployeeTypes(tempEmployeeTypes);
//                   setShowLeaveModal(false);
//                 }}
//               >
//                 Apply
//               </button>
//             </div>

//           </div>
//         </div>
//       )}
//     </div>
//   );
// }



















import React, { useState, useEffect } from "react";
import { PDFDocument, StandardFonts } from "pdf-lib";
import Select from "react-select";
import "../styles/Invoice.css";

export default function InvoiceGenerator() {

  const [showLeaveModal, setShowLeaveModal] = useState(false);
  const [leaveEmployees, setLeaveEmployees] = useState([]);
  const [employeeTypes, setEmployeeTypes] = useState({});
  const [tempEmployeeTypes, setTempEmployeeTypes] = useState({});
  const [headcountErrors, setHeadcountErrors] = useState({});

  const [lineItems, setLineItems] = useState([
    { rate: "", headcount: "", hours: "", auto: true } // ✅ first row auto
  ]);

  const [form, setForm] = useState({
    department: "",
    month: "",
    year: "",
    serviceDate: "",
    buyer: "Intel Corporation",
    address: "Hillsboro, Oregon",
    country: "USA",
    total: ""
  });


  const departmentOptions = [
  { value: "FI Design", label: "FI Design" },
  { value: "FSPLO", label: "FSPLO" },
  { value: "LTDM PC", label: "LTDM PC" },
  { value: "DDI", label: "DDI" },
  { value: "DMS", label: "DMS" },
  { value: "FI-IE", label: "FI-IE" },
  { value: "LTO", label: "LTO" }
];

const monthOptions = [
  { value: "Jan", label: "Jan" },
  { value: "Feb", label: "Feb" },
  { value: "Mar", label: "Mar" },
  { value: "Apr", label: "Apr" },
  { value: "May", label: "May" },
  { value: "Jun", label: "Jun" },
  { value: "Jul", label: "Jul" },
  { value: "Aug", label: "Aug" },
  { value: "Sep", label: "Sep" },
  { value: "Oct", label: "Oct" },
  { value: "Nov", label: "Nov" },
  { value: "Dec", label: "Dec" }
];

const yearOptions = [
  { value: "2026", label: "2026" },
  { value: "2027", label: "2027" }
];

  const [leaveLoading, setLeaveLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [leaveDeduction, setLeaveDeduction] = useState({
    days: 0,
    hours: 0
  });


  const fetchLeaveEmployees = async () => {
    try {
      const monthMap = {
        Jan: 1, Feb: 2, Mar: 3, Apr: 4,
        May: 5, Jun: 6, Jul: 7, Aug: 8,
        Sep: 9, Oct: 10, Nov: 11, Dec: 12
      };

      const res = await fetch(
        `/gt-api/get_leave_details.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
      );

      const data = await res.json();

      if (data.success) {
        setLeaveEmployees(data.employees);
      } else {
        setLeaveEmployees([]);
      }

    } catch (err) {
      console.error(err);
      setLeaveEmployees([]);
    }
  };




  const fetchLeavesForInvoice = async () => {
    try {
      setLeaveLoading(true); // ✅ START LOADING

      const monthMap = {
        Jan: 1, Feb: 2, Mar: 3, Apr: 4,
        May: 5, Jun: 6, Jul: 7, Aug: 8,
        Sep: 9, Oct: 10, Nov: 11, Dec: 12
      };

      const res = await fetch(
        `/gt-api/get_leave_deduction.php?department=${encodeURIComponent(form.department)}&month=${monthMap[form.month]}&year=${form.year}`
      );

      const data = await res.json();

      if (data.success) {
        setLeaveDeduction({
          days: data.days,
          hours: data.hours
        });
      } else {
        setLeaveDeduction({ days: 0, hours: 0 });
      }

    } catch (err) {
      console.error("Leave API error", err);
      setLeaveDeduction({ days: 0, hours: 0 });
    } finally {
      setLeaveLoading(false);
    }
  };
  useEffect(() => {
    if (!form.headcount || !form.month || !form.year) return;

    // ❌ WAIT until API is done
    if (leaveLoading) return;

    const hoursPerDay = 8;

    const workingDays = getWorkingDays(form.month, form.year);

    const headcount = Number(form.headcount) || 0;

    const baseTWHM = headcount * hoursPerDay * workingDays;

    const deductionHours = Number(leaveDeduction.hours) || 0;

    const finalTWHM = baseTWHM - deductionHours;

    setForm(prev => {
      if (prev.hours === finalTWHM) return prev;

      return {
        ...prev,
        hours: Math.max(0, finalTWHM)
      };
    });

  }, [
    form.headcount,
    form.month,
    form.year,
    leaveDeduction.hours,
    leaveLoading   // ✅ IMPORTANT
  ]);

  // 🔥 AUTO CALCULATE TWHM FOR EACH LINE ITEM

  useEffect(() => {
    if (!form.month || !form.year) return;
    if (leaveLoading) return;
    if (!leaveEmployees.length) return; // ✅ ADD THIS

    const hoursPerDay = 8;
    const workingDays = getWorkingDays(form.month, form.year);

    // 🔥 ALWAYS START FROM BASE
    let updatedItems = lineItems.map((item) => {
      const headcount = Number(item.headcount || 0);
      const baseTWHM = headcount * hoursPerDay * workingDays;

      return {
        ...item,
        hours: baseTWHM
      };
    });

    // 🔥 GROUP
    const typeTotals = {};

    Object.keys(employeeTypes).forEach((empIndex) => {
      const type = Number(employeeTypes[empIndex]);
      const emp = leaveEmployees[empIndex];

      if (!type || !emp) return;

      if (!typeTotals[type]) {
        typeTotals[type] = 0;
      }

      typeTotals[type] += Number(emp.unit || 0);
    });

    // 🔥 APPLY ONCE
    Object.keys(typeTotals).forEach((type) => {
      const rowIndex = Number(type) - 1;

      if (!updatedItems[rowIndex]) return;

      const totalUnits = typeTotals[type];

      updatedItems[rowIndex].hours -= totalUnits * hoursPerDay;
    });

    setLineItems(updatedItems);

  }, [
    lineItems.map(i => i.headcount).join(),
    form.month,
    form.year,
    leaveLoading,
    employeeTypes,
    leaveEmployees
  ]);

  useEffect(() => {
    console.log("TRIGGER CHECK:", form);

    if (form.department && form.month && form.year) {
      console.log("CALLING API 🚀");
      fetchLeavesForInvoice();
    }
  }, [form.department, form.month, form.year]);

  useEffect(() => {
    if (!form.month || !form.year) return;

    const monthIndexMap = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3,
      May: 4, Jun: 5, Jul: 6, Aug: 7,
      Sep: 8, Oct: 9, Nov: 10, Dec: 11
    };

    const monthIndex = monthIndexMap[form.month];
    const year = Number(form.year);

    const lastDay = new Date(year, monthIndex + 1, 0).getDate();

    const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;

    setForm(prev => {
      if (prev.serviceDate === formattedDate) return prev;

      return {
        ...prev,
        serviceDate: formattedDate
      };
    });

  }, [form.month, form.year]);

  const [invoiceNo, setInvoiceNo] = useState(1);

  function getFinancialYear(month, year) {
    if (!month || !year) return "";

    const monthIndex = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3,
      May: 4, Jun: 5, Jul: 6, Aug: 7,
      Sep: 8, Oct: 9, Nov: 10, Dec: 11
    }[month];

    let startYear, endYear;

    if (monthIndex >= 3) { // April onwards
      startYear = year;
      endYear = Number(year) + 1;
    } else {
      startYear = Number(year) - 1;
      endYear = year;
    }

    return `${String(startYear).slice(-2)}-${String(endYear).slice(-2)}`;
  }

  useEffect(() => {
    const fy = getFinancialYear(form.month, form.year);
    if (!fy) return;

    const stored = localStorage.getItem(`invoice-${fy}`);
    setInvoiceNo(stored ? Number(stored) : 1);
  }, [form.month, form.year]);



  function getWorkingDays(month, year) {
    if (!month || !year) return 0;

    const monthIndex = {
      Jan: 0, Feb: 1, Mar: 2, Apr: 3,
      May: 4, Jun: 5, Jul: 6, Aug: 7,
      Sep: 8, Oct: 9, Nov: 10, Dec: 11
    }[month];

    let count = 0;
    const daysInMonth = new Date(year, monthIndex + 1, 0).getDate();

    for (let d = 1; d <= daysInMonth; d++) {
      const day = new Date(year, monthIndex, d).getDay();
      if (day !== 0 && day !== 6) count++; // exclude Sun & Sat
    }

    return count;
  }
  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm(prev => {
      let updatedForm = { ...prev, [name]: value };

      const hoursPerDay = 8;

      const workingDays = getWorkingDays(
        name === "month" ? value : updatedForm.month,
        name === "year" ? value : updatedForm.year
      );

      // 🔥 AUTO CALCULATE WHEN HEADCOUNT / MONTH / YEAR CHANGES
      if (
        name === "headcount" ||
        name === "month" ||
        name === "year"
      ) {
        const headcount = Number(
          name === "headcount" ? value : updatedForm.headcount
        ) || 0;
      }

      // ✅ AUTO-FILL SERVICE DATE
      if (name === "invoiceDate") {
        if (!prev.serviceDate || prev.serviceDate === prev.invoiceDate) {
          updatedForm.serviceDate = value;
        }
      }

      return updatedForm;
    });
  };

  const handleLineChange = (index, e) => {
    const { name, value } = e.target;

    const updated = [...lineItems];
    updated[index][name] = value;

    setLineItems(updated);

    // 🔥 VALIDATE HEADCOUNT (REAL-TIME)
    if (name === "headcount") {
      const type = index + 1; // row1 → Type1

      let selectedCount = 0;

      // count employees selected for this type
      Object.keys(employeeTypes).forEach((empIndex) => {
        if (Number(employeeTypes[empIndex]) === type) {
          selectedCount++;
        }
      });

      const enteredHeadcount = Number(value || 0);

      setHeadcountErrors(prev => ({
        ...prev,
        [index]:
          enteredHeadcount < selectedCount
            ? `Minimum ${selectedCount} required`
            : ""
      }));
    }
  };

  const addLineItem = () => {
    setLineItems(prev => [
      ...prev,
      {
        rate: "",
        headcount: "",
        hours: 0,
        auto: false
      }
    ]);
  };

  const deleteLineItem = (index) => {
    setLineItems(prev => prev.filter((_, i) => i !== index));
  };


  const calculateTotal = () => {
    if (form.total !== "") {
      return Number(form.total) || 0;
    }

    return lineItems.reduce((sum, item) => {
      return sum + (Number(item.rate) * Number(item.hours));
    }, 0);
  };

  // 🔥 form fields
  // 🔥 remove total
  const { total, ...restForm } = form;

  // 🔥 form fields
  const formFields = Object.values(restForm);

  // 🔥 line items
  const lineItemFields = lineItems.flatMap(item => [
    item.rate,
    item.headcount,
    item.hours
  ]);

  // 🔥 combine
  const allFields = [...formFields, ...lineItemFields];

  // 🔥 count
  const filled = allFields.filter(v => v !== "" && v !== null).length;

  // 🔥 %
  const progress = Math.round((filled / allFields.length) * 100);

  const isComplete = progress === 100;

  function numberToWords(num) {
    if (num === 0) return "Zero Dollars Only";

    const ones = [
      "", "One", "Two", "Three", "Four", "Five", "Six",
      "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve",
      "Thirteen", "Fourteen", "Fifteen", "Sixteen",
      "Seventeen", "Eighteen", "Nineteen"
    ];

    const tens = [
      "", "", "Twenty", "Thirty", "Forty", "Fifty",
      "Sixty", "Seventy", "Eighty", "Ninety"
    ];

    const thousands = ["", "Thousand", "Million", "Billion"];

    function convertHundreds(n) {
      let str = "";

      if (n > 99) {
        str += ones[Math.floor(n / 100)] + " Hundred ";
        n %= 100;
      }

      if (n > 19) {
        str += tens[Math.floor(n / 10)] + " ";
        n %= 10;
      }

      if (n > 0) {
        str += ones[n] + " ";
      }

      return str.trim();
    }

    let word = "";
    let i = 0;

    while (num > 0) {
      if (num % 1000 !== 0) {
        word =
          convertHundreds(num % 1000) +
          " " +
          thousands[i] +
          " " +
          word;
      }
      num = Math.floor(num / 1000);
      i++;
    }

    return word.trim() + " Dollars Only";
  }

  // 🔥 Generate PDF
  const generatePDF = async () => {
    const existingPdfBytes = await fetch("/InvoiceTemplate.pdf")
      .then(res => res.arrayBuffer());

    const pdfDoc = await PDFDocument.load(existingPdfBytes);
    const page = pdfDoc.getPages()[0];

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const fy = getFinancialYear(form.month, form.year);

    // const date = form.serviceDate || "";
    const formatInvoiceDate = (dateValue) => {
  if (!dateValue) return "";

  const date = new Date(dateValue);

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
};


const formatServiceMonth = () => {
  if (!form.month || !form.year) return "";

  const monthMap = {
    Jan: "January",
    Feb: "February",
    Mar: "March",
    Apr: "April",
    May: "May",
    Jun: "June",
    Jul: "July",
    Aug: "August",
    Sep: "September",
    Oct: "October",
    Nov: "November",
    Dec: "December"
  };

  return `${monthMap[form.month]} ${form.year}`;
};


const invoiceDate = formatInvoiceDate(form.serviceDate);

const serviceMonth = formatServiceMonth();

    const total = calculateTotal();

   // Invoice Date -> 30 June 2026
page.drawText(invoiceDate, {
  x: 204.5,
  y: 595,
  size: 10,
  font
});


// Service Rendered Month -> June 2026
page.drawText(serviceMonth, {
  x: 204.5,
  y: 581,
  size: 10,
  font
});

    page.drawText(form.buyer || "", { x: 204.5, y: 519.5, size: 10, font });
    page.drawText(form.address || "", { x: 204.5, y: 504.5, size: 10, font });
    page.drawText(form.country || "", { x: 204.5, y: 482, size: 10, font });

    page.drawText(`$${total}`, { x: 455, y: 368.5, size: 10, font });
    page.drawText(`$${total}`, { x: 455, y: 348, size: 10, font });
    page.drawText(`$${total}`, {
      x: 455,
      y: 315.5,
      size: 10,
      font: boldFont
    });

    page.drawText(numberToWords(total), {
      x: 204,
      y: 235,
      size: 10,
      font: boldFont
    });


    page.drawText(`GTEPL/${fy}/${invoiceNo}`, {
      x: 204.5,
      y: 565,
      size: 10,
      font
    });

    return await pdfDoc.save();
  };

useEffect(() => {
  const updatePreview = async () => {
    const bytes = await generatePDF();

    const blob = new Blob(
      [bytes],
      { type: "application/pdf" }
    );

    const url = URL.createObjectURL(blob);

    setPreviewUrl(prev => {
      if (prev) URL.revokeObjectURL(prev);
      return url;
    });
  };

  updatePreview();

}, [
  form,
  lineItems,
  invoiceNo
]);

  const validateHeadcount = () => {
    const typeCounts = {};

    // count employees per type
    Object.keys(employeeTypes).forEach((empIndex) => {
      const type = Number(employeeTypes[empIndex]);
      if (!type) return;

      if (!typeCounts[type]) {
        typeCounts[type] = 0;
      }

      typeCounts[type]++;
    });

    // validate against lineItems
    for (let type in typeCounts) {
      const rowIndex = Number(type) - 1;

      const selectedEmployees = typeCounts[type];
      const headcount = Number(lineItems[rowIndex]?.headcount || 0);

      if (headcount < selectedEmployees) {
        alert(
          `❌ Please enter appropriate headcount for Type${type} (minimum ${selectedEmployees})`
        );
        return false;
      }
    }

    return true;
  };

  const downloadPDF = async () => {
    const bytes = await generatePDF();
    const blob = new Blob([bytes], { type: "application/pdf" });

    const fy = getFinancialYear(form.month, form.year);

    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `GTEPL_${fy}_${invoiceNo}.pdf`;
    a.click();

    const next = invoiceNo + 1;

    localStorage.setItem(`invoice-${fy}`, next);
    setInvoiceNo(next);
  };

  return (
    <div className="main-container">

      {/* 🔽 MAIN CONTENT AREA (IMPORTANT WRAPPER) */}
      <div className="page-content">

        {/* 🔥 HEADER ROW (NOW CORRECT POSITION) */}
        {/* HEADER FILTERS */}
<div className="header-bar">

  <div className="filter-group department-filter">
    <select
      name="department"
      value={form.department || ""}
      onChange={handleChange}
    >
      <option value="">Department</option>
      <option value="FI Design">FI Design</option>
      <option value="FSPLO">FSPLO</option>
      <option value="LTDM PC">LTDM PC</option>
      <option value="DDI">DDI</option>
      <option value="DMS">DMS</option>
      <option value="FI-IE">FI-IE</option>
      <option value="LTO">LTO</option>
    </select>
  </div>

  <div className="filter-group">
    <select
      name="month"
      value={form.month || ""}
      onChange={handleChange}
    >
      <option value="">Month</option>
      <option value="Jan">Jan</option>
      <option value="Feb">Feb</option>
      <option value="Mar">Mar</option>
      <option value="Apr">Apr</option>
      <option value="May">May</option>
      <option value="Jun">Jun</option>
      <option value="Jul">Jul</option>
      <option value="Aug">Aug</option>
      <option value="Sep">Sep</option>
      <option value="Oct">Oct</option>
      <option value="Nov">Nov</option>
      <option value="Dec">Dec</option>
    </select>
  </div>

  <div className="filter-group">
    <select
      name="year"
      value={form.year || ""}
      onChange={handleChange}
    >
      <option value="">Year</option>
      <option value="2026">2026</option>
      <option value="2027">2027</option>
    </select>
  </div>

</div>

        

        {/* 🔽 BELOW HEADER */}
        <div className="content-area">

          {/* LEFT */}
          <div className="form-section">



            <div className="invoice-header">
              <h2>⚡ Create Invoice</h2>

              {/* 🔥 NEW ROW */}
              <div className="invoice-row">

                <div className="invoice-no-box">
                  <span>
                    GTEPL/{getFinancialYear(form.month, form.year)}/{invoiceNo}
                  </span>

                  <div className="invoice-controls">
                    <button onClick={() => setInvoiceNo(prev => Math.max(1, prev - 1))}>−</button>
                    <button onClick={() => setInvoiceNo(prev => prev + 1)}>+</button>
                  </div>
                </div>

                <div className="metrics-row">
                  <div className="metric-card working-days-card">
                    <div className="metric-title">WORKING DAYS</div>
                    <div className="metric-value">
                      {getWorkingDays(form.month, form.year)}
                    </div>
                  </div>

                  <div className="metric-card deduction-card">

                    <div className="metric-title">
                      DEDUCTION
                      <span
                        className="info-icon"
                        title="View leave details"
                        onClick={() => {
                          fetchLeaveEmployees();   // 🔥 call API for employee-wise leaves
                          setShowLeaveModal(true); // 🔥 open popup
                        }}
                      >
                        ⓘ
                      </span>
                    </div>

                    {leaveLoading ? (
                      <div className="metric-note">Calculating...</div>
                    ) : leaveDeduction.days > 0 ? (
                      <div className="metric-note">
                        ⚠ {leaveDeduction.days} days = {leaveDeduction.hours} hrs deducted
                      </div>
                    ) : (
                      <div className="metric-note success">
                        No deductions
                      </div>
                    )}

                  </div>


                </div>

              </div>
            </div>

            <div className="form-grid">

              {/* ADD BUTTON */}
              <button className="add-btn" type="button" onClick={addLineItem}>
                + Add Line Item
              </button>

              {/* LINE ITEMS */}
              <div className="line-items">
                {lineItems.map((item, index) => (
                  <div className="row" key={index}>

                    {/* TOP RIGHT DELETE ICON */}
                    <span
                      className="delete-icon"
                      onClick={() => deleteLineItem(index)}
                    >
                      ✖
                    </span>

                    <div className="field">
                      <label>Rate</label>
                      <input
                        name="rate"
                        value={item.rate}
                        onChange={(e) => handleLineChange(index, e)}
                      />
                    </div>

                    <div className="field">
                      <label>Headcount</label>

                      <input
                        name="headcount"
                        value={item.headcount}
                        onChange={(e) => handleLineChange(index, e)}
                        className={headcountErrors[index] ? "input-error" : ""}
                      />

                      {headcountErrors[index] && (
                        <div className="error-text">
                          {headcountErrors[index]}
                        </div>
                      )}
                    </div>

                    <div className="field">
                      <label>TWHM</label>
                      <input
                        name="hours"
                        value={item.hours}
                        onChange={(e) => handleLineChange(index, e)}
                      />
                    </div>

                  </div>
                ))}
              </div>

              {/* DIVIDER */}
              <div className="divider"></div>

              {/* STATIC SECTION */}
              <div className="row">
                <div className="field">
                  <label>Name of the Buyer</label>
                  <input name="buyer" value={form.buyer} onChange={handleChange} />
                </div>

                <div className="field">
                  <label>Address</label>
                  <input name="address" value={form.address} onChange={handleChange} />
                </div>

                <div className="field">
                  <label>Country Name</label>
                  <input name="country" value={form.country} onChange={handleChange} />
                </div>
              </div>

              {/* <div className="field">
                <label>Date (Invoice & Service)</label>
                <input
                  type="date"
                  name="serviceDate"
                  value={form.serviceDate}
                  onChange={handleChange}
                />
              </div> */}



            </div>
            <div className="row">
              <div className="field">
                <label>Date (Invoice & Service)</label>
                <input
                  type="date"
                  name="serviceDate"
                  value={form.serviceDate}
                  onChange={handleChange}
                />
              </div>

              <div className="field">
                <label>Total Amount</label>

                <div className="currency-input">
                  <span className="currency-symbol">$</span>

                  <input
                    name="total"
                    value={form.total !== "" ? form.total : calculateTotal()}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>
            {/* <div className="total-box">
              <span>Total Amount</span>

              <input
                name="total"
                value={form.total !== "" ? form.total : calculateTotal()}
                onChange={handleChange}
                className="total-input"
              />
            </div> */}

            <div className="progress-wrapper bottom-progress">
              <div className="progress-bar">
                <div style={{ width: `${progress}%` }} />
              </div>
              <br />
              <div className="btn-wrapper">
                <button
                  disabled={!isComplete}
                  className={isComplete ? "btn-active" : "btn-disabled"}
                  onClick={downloadPDF}
                >
                  Generate PDF
                </button>
              </div>
            </div>
            <br />

          </div>





          {/* RIGHT */}
          <div className="preview-section">
            <div className="preview-card">
              <center>
                <div className="preview-header">Live Invoice Preview</div>
              </center>
              {previewUrl ? (

                <iframe
                  src={`${previewUrl}#toolbar=0&view=FitH&zoom=auto`}
                  title="preview"
                />


              ) :
                (
                  <p style={{ color: "#64748b" }}>Fill details to preview</p>
                )
              }
            </div>
          </div>

        </div>

      </div>
      {showLeaveModal && (
        <div
          className="inv-modal-overlay"
          onClick={() => setShowLeaveModal(false)}  // 🔥 close on outside click
        >
          <div
            className="inv-modal-box"
            onClick={(e) => e.stopPropagation()}   // 🔥 prevent inside click close
          >
            <button
              className="inv-modal-close-btn"
              onClick={() => setShowLeaveModal(false)}
            >
              ✕
            </button>

            {/* HEADER */}
            <div className="inv-modal-header">
              <div>
                <h3>Leave Details</h3>
                <p className="inv-modal-subtitle">Review employee leave details and classify them into respective invoice types.</p>
              </div>
            </div>

            {/* TABLE */}
            <table className="inv-leave-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Unit</th>
                  <th>Type</th>
                </tr>
              </thead>

              <tbody>
                {leaveEmployees.length > 0 ? (
                  leaveEmployees.map((emp, i) => (
                    <tr key={i}>
                      <td>{emp.name}</td>
                      <td>{emp.unit}</td>
                      <td>
                        <select
                          className="inv-type-dropdown"
                          value={tempEmployeeTypes[i] || ""}
                          onChange={(e) => {
                            const updated = {
                              ...tempEmployeeTypes,
                              [i]: e.target.value
                            };
                            setTempEmployeeTypes(updated);
                          }}
                        >
                          <option value="">Select</option>
                          <option value="1">Type1</option>
                          <option value="2">Type2</option>
                          <option value="3">Type3</option>
                          <option value="4">Type4</option>
                          <option value="5">Type5</option>
                        </select>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="no-data">
                      No leave records
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {/* 🔥 BUTTONS */}
            <div className="inv-modal-footer">
              <button
                className="inv-cancel-btn"
                onClick={() => setShowLeaveModal(false)}
              >
                Cancel
              </button>
              <button
                className="inv-apply-btn"
                onClick={() => {
                  setEmployeeTypes(tempEmployeeTypes);
                  setShowLeaveModal(false);
                }}
              >
                Apply
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}



